import React from 'react';
import AppSettingsConfig from '../components/AppSettings/Index';

function AppSettings() {
	return (
		<>
			<AppSettingsConfig />
		</>
	)
}

export default AppSettings